import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { LEAD_REAL_ESTATE } from '../../shared/constants/strings';
import { environment } from '../../../environments/environment';
import { ImgUrls } from '../../shared/models/imgUrls.interface';
import { ImageCarouselModalContentComponent } from '../../shared/components/image-carousel-modal-content/image-carousel-modal-content.component';
import { UtilService } from '../../shared/util.service';
import { MetadataService } from '../../shared/services/metadata.service';
import { TitleService } from '../../shared/services/title.service';
import { ThumbnailWidgetComponent } from '../../shared/components/thumbnail-widget/thumbnail-widget.component';

const PHOTO_COUNT_OBJECT = 17;

@Component({
  selector: 'app-real-estate',
  templateUrl: './real-estate.component.html',
  styleUrls: ['./real-estate.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, MatButtonModule, MatIconModule, MatDialogModule, ThumbnailWidgetComponent],
})
export class RealEstateComponent implements OnInit {
  activeImageIndexObject = 0;
  imgPath = environment.storageImgPath;
  imgPathRealEstate = this.imgPath + '/real-estate/';
  titleImage = this.imgPathRealEstate + 'real-estate-w600.webp';
  imgUrlsObject: ImgUrls[] = [];

  constructor(
    private dialog: MatDialog,
    private metadataService: MetadataService,
    private utilService: UtilService,
    private titleService: TitleService,
  ) {}

  public get LEAD_REAL_ESTATE() {
    return LEAD_REAL_ESTATE;
  }

  ngOnInit(): void {
    this.titleService.setTitle(`Immobilien`);
    this.metadataService.updateTags(
      `Immobilien`,
      `Hier erfahren mehr über meine Werte und Strategie als Immobilieninvestor`,
      `Immobilien Strategie Miete Kauf Wohnung Haus`,
      [this.titleImage],
    );
    this.createImgUrls(1, PHOTO_COUNT_OBJECT, 'carouselObject');
  }

  /**
   * Opens the given array of images in a carousel inside a modal.
   * @param selectedId the ID of the image to be selected at the beginning
   * @param imgUrls all images to be shown in the carousel
   */
  openImage(selectedId: number, imgUrls: ImgUrls[]): void {
    this.dialog.open(ImageCarouselModalContentComponent, {
      panelClass: 'image-carousel-dialog',
      data: { selectedId, imgUrls, altName: imgUrls[selectedId].title },
    });
  }

  selectImage(index: number, carousel: 'carouselObject') {
    this.setActiveIndex(carousel, index);
  }

  previousImage(carousel: 'carouselObject'): void {
    const { items, activeIndex } = this.getCarouselState(carousel);
    if (!items.length) return;
    const newIndex = (activeIndex - 1 + items.length) % items.length;
    this.setActiveIndex(carousel, newIndex);
  }

  nextImage(carousel: 'carouselObject'): void {
    const { items, activeIndex } = this.getCarouselState(carousel);
    if (!items.length) return;
    const newIndex = (activeIndex + 1) % items.length;
    this.setActiveIndex(carousel, newIndex);
  }

  getActiveImage(carousel: 'carouselObject'): ImgUrls | undefined {
    const state = this.getCarouselState(carousel);
    return state.items[state.activeIndex];
  }

  private createImgUrls(firstIndex: number, lastIndex: number, carousel: 'carouselObject') {
    switch (carousel) {
      case 'carouselObject':
        this.imgUrlsObject = [];
        for (let i = firstIndex; i <= lastIndex; i++)
          this.imgUrlsObject.push({
            w150: this.imgPathRealEstate + `object${i}-w150.webp`,
            w350: this.imgPathRealEstate + `object${i}-w350.webp`,
            w500: this.imgPathRealEstate + `object${i}-w500.webp`,
            w750: this.imgPathRealEstate + `object${i}-w750.webp`,
            w1124: this.imgPathRealEstate + `object${i}-w1124.webp`,
            w1500: this.imgPathRealEstate + `object${i}-w1500.webp`,
            full: this.imgPathRealEstate + `object${i}-w2000.webp`,
            title: `Objektfoto ${i}`,
          });
        break;
    }
  }

  private getCarouselState(carousel: 'carouselObject') {
    switch (carousel) {
      case 'carouselObject':
        return { items: this.imgUrlsObject, activeIndex: this.activeImageIndexObject };
    }
  }

  private setActiveIndex(carousel: 'carouselObject', index: number): void {
    switch (carousel) {
      case 'carouselObject':
        this.activeImageIndexObject = index;
        break;
    }
    this.utilService.scrollToId(carousel);
  }
}
